import './navbar.css';

function Navbar(){
    return(
      <div className="Navbar">
      <ul class="topnav">
      <li><a href="#home">Home</a></li>
      <li><a href="#contact">Contact</a></li>
      <li><a href="#about">About</a></li>
    </ul>
    
    
    </div>

        )
}
export default Navbar;